(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendation-ACF"] && !Shopify.designMode) return;
  try {
    

 var swiper = new Swiper('.swiper-container', {
            spaceBetween: 13,
            slidesPerView: '1.6',
            watchOverflow: true,
            loop: false,
            speed: 800,
            pagination: {
              el: swiperSlider,
              type: 'progressbar',
            },
            navigation: {
              nextEl: nextArrow,
              prevEl: prevArrow,
            },
            breakpoints: {
              768: {
                spaceBetween: 40,
                slidesPerView: '2.645',
                pagination: {
                  el: swiperSlider,
                  type: 'progressbar',
                },
                navigation: {
                  nextEl: nextArrow,
                  prevEl: prevArrow,
                },
              },
            }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-product-row"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }})
      .then(() => {
        $('.js-product-row-gallery').each( function() {
          const swiperName = $(this).data('swiper');
          const swiperId = $(this).data('swiper-id');
          const nextArrow = ".swiper-button-next-" + swiperId;
          const prevArrow = ".swiper-button-prev-" + swiperId;
          const swiperSlider = ".swiper-slider-" + swiperId;

          const featuredGallery = new Swiper('[data-swiper=' + swiperName + ']', {
            spaceBetween: 13,
            slidesPerView: '1.6',
            watchOverflow: true,
            loop: false,
            speed: 800,
            pagination: {
              el: swiperSlider,
              type: 'progressbar',
            },
            navigation: {
              nextEl: nextArrow,
              prevEl: prevArrow,
            },
            breakpoints: {
              768: {
                spaceBetween: 40,
                slidesPerView: '2.645',
                pagination: {
                  el: swiperSlider,
                  type: 'progressbar',
                },
                navigation: {
                  nextEl: nextArrow,
                  prevEl: prevArrow,
                },
              },
            }
          });
        })
      })
      .catch(e => {
        console.error(e);
      });
    };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
